/**
 * Dashboard copy: the personal lists and their empty states.
 */

export interface DashboardCopy {
  readonly dashboard: {
    readonly title: string;
    readonly myActiveTask: string;
    readonly readyForYou: string;
    readonly waitingOnYou: string;
    readonly recentlyCompleted: string;
    readonly ownerControls: string;
    readonly proposalsPending: string;
    readonly emptyActive: string;
    readonly emptyReady: string;
    readonly emptyWaiting: string;
    readonly emptyCompleted: string;
    readonly emptyProposals: string;
    readonly viewBoard: string;
  };
}

export const DASHBOARD_COPY_EN: DashboardCopy = {
  dashboard: {
    title: 'Dashboard',
    myActiveTask: 'My active task',
    readyForYou: 'Ready for you',
    waitingOnYou: 'Waiting on you',
    recentlyCompleted: 'Recently completed',
    ownerControls: 'Owner controls',
    proposalsPending: 'Proposals awaiting a decision',
    emptyActive: 'You have no task in progress. Claim one from Ready for you.',
    emptyReady: 'Nothing is waiting to be claimed right now.',
    emptyWaiting: 'No submissions are waiting for your review.',
    emptyCompleted: 'Nothing has been completed recently.',
    emptyProposals: 'No proposals are waiting.',
    viewBoard: 'Open the task board',
  },
};

export const DASHBOARD_COPY_AR: DashboardCopy = {
  dashboard: {
    title: 'لوحة العمل',
    myActiveTask: 'مهمتي النشطة',
    readyForYou: 'جاهزة لك',
    waitingOnYou: 'بانتظارك',
    recentlyCompleted: 'أُنجزت مؤخرًا',
    ownerControls: 'أدوات المالك',
    proposalsPending: 'مقترحات بانتظار قرار',
    emptyActive: 'لا توجد مهمة قيد التنفيذ لديك. استلم واحدة من «جاهزة لك».',
    emptyReady: 'لا شيء بانتظار الاستلام حاليًا.',
    emptyWaiting: 'لا توجد تسليمات بانتظار مراجعتك.',
    emptyCompleted: 'لم يُنجز شيء مؤخرًا.',
    emptyProposals: 'لا توجد مقترحات بانتظار قرار.',
    viewBoard: 'فتح لوحة المهام',
  },
};
